module.exports = __webpack_public_path__ + "static/media/matilde-hat-greece-tired.44277bdc.png";